import { parseHealthEvent, type HealthEvent } from '../domain/health';
const sent = new Map<string, number>();
let count = 0;
let enabled = false;
export function setMonitoringEnabled(value: boolean) { enabled = value; }
export function reportHealth(event: Omit<HealthEvent, 'release'>) {
  if (!enabled || !navigator.onLine || count >= 20) return;
  const parsed = parseHealthEvent({ ...event, release: import.meta.env.VITE_APP_RELEASE ?? 'local' });
  if (!parsed) return;
  const key = `${event.event}:${event.area}:${event.code}`;
  if (Date.now() - (sent.get(key) ?? 0) < 300_000) return;
  sent.set(key, Date.now()); count++;
  void fetch('/api/health-event', { method: 'POST', credentials: 'include', headers: {'content-type':'application/json'}, body: JSON.stringify(parsed), keepalive: true, signal: AbortSignal.timeout(5000) }).catch(() => undefined);
}
export function installMonitoring() {
  window.addEventListener('error', () => reportHealth({event:'crash',area:'app',code:'unknown'}));
  window.addEventListener('unhandledrejection', () => reportHealth({event:'unhandled',area:'app',code:'unknown'}));
}
